import React from 'react';
import {
	Typography, Card, Box,
	CardHeader, CardContent
} from '@mui/material';
import "react-image-gallery/styles/css/image-gallery.css";
import moment from 'moment';
import { locations } from '../components/views/constants';

const classes = {
	cardContainer: {
		boxShadow: 'unset',
		padding: '15px',
	},
	cardContent: {
		display: 'flex',
		alignItems: 'left',
		padding: 'unset',
		flexDirection: 'column',
		'&:last-child': {
			paddingleft: 8,
			paddingBottom: 0,
		},
	},
	media: {
		//height: '140px',
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		backgroundColor: '#ececec',	
	},
	eventLink: {
		textDecoration: 'none !important'
	},
	categoryLabel: {
		position: 'absolute',
		top: 0,
		color: 'white',
		borderRadius: '5px',
		height: '20px',
		padding: '0 10px',
		display: 'flex',
		margin: '10px',
		alignItems: 'center',
		// backgroundColor: props => `${categoryColor(props.event.category_id)}`,
		'& p': {
			padding: 'unset',
			margin: 'unset',
			textTransform: 'uppercase', 
			fontSize: '10px'
		}
	},
	categoryTab: {
		// backgroundColor: props => `${categoryColor(props.event.category_id)}`,
		display: 'inline-flex',
		alignItems: 'center',
		color: 'white',
		height: '30px',
		padding: '0 10px',
		textTransform: 'uppercase',
		fontSize: '10px'
	},
	registerUrl: {
		textDecoration: 'none',
		fontFamily: 'Lato, sans-serif',
		fontSize: '17px',
		fontWeight: '700',
		'&. *': {
			textDecoration: 'none',
		},
	},
	cardInfoLine: {
		display: 'flex',
		alignItems: 'start',
		flexWrap: 'wrap',
		flexDirection: 'column',
		textAlign: 'left',
	},
	cardInfoTitle: {
		fontWeight: '700',
		fontFamily: 'Lato, sans-serif',
		color: '#3D3D3D',
		fontStyle: 'normal',
		fontSize: '15px',
		margin: '10px 0',
		width: '100%',
		textAlign: 'left',
		display: '-webkit-box',
		WebkitLineClamp: 3,
		WebkitBoxOrient: 'vertical',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		letterSpacing: '-0.3px',
	},
};

const EventCard = (props) => {
	const event = props.event.attributes;
	let cardEventHeader = (event) => {
		return(
			<Box className={classes.media}>
				{headerImg()}
				{event.category_name !== null ? (
					<div className={classes.categoryLabel} ><p>{event.category_name}</p></div>
				) : (
					null
				)}	
			</Box>
		)
	}

	let headerImg = () => {
		let url = ''
		let eventEndDate = Date.parse(event.end_date)
		let minEndDate = Date.parse('Apr 07, 2020')
		if(event?.banner_image?.medium !== null && eventEndDate < minEndDate){
			url = event.hero.large_url?.replace('/large/', '/original/')
			return <img src={url} alt='img' style={{objectFit: 'cover', aspectRatio: '2 / 1', width: '100%'}} />
		}
		if(event?.logo?.medium !== null){
			url = event?.logo?.medium;
			if(url.includes('missing')) {
				return (
					<div
						className='event-img-container'
						style={{
							display: 'flex',
							justifyContent: 'center',
							width:'100%',
							aspectRatio: '2 / 1',
							backgroundColor: '#d1cdcd',
						}}>
					</div>
				);
			};
		}
		return (
			<div
				className='event-img-container'
				style={{
					display: 'flex',
					justifyContent: 'center',
					width:'100%'
				}}
			>
				<img
					src={url}
					alt='img'
					style={{
						objectFit: 'cover',
						aspectRatio: '2 / 1',
						width: '100%'
					}}
				/>
			</div>
		);
	};

	const getLabel = (loc) => {
		const label = locations.find(item => item.value === loc)?.label;
		return label;
	};

	const eventURL = event?.event_uri
		? `https://event.eurobiomed.org/${event?.website_languages?.[0]}/${event.event_uri}` : event?.website;

	return (
		<Card sx={classes.cardContainer}>
			{event.category_name !== null ? (
				<div style={{textAlign: 'left'}}>
					<span className={classes.categoryTab}>
						{event.category_name}
					</span>
				</div>
				
			) : (
				null
			)}
			<Typography
				component="a"
				href={eventURL}
				target='_blank'
				rel="noopener noreferrer"
				sx={classes.registerUrl}
			>
				<CardHeader
					component={() => cardEventHeader(event)}
				/>
				<CardContent sx={classes.cardContent}>
					<Typography sx={classes.cardInfoTitle}>
						{event.name}
					</Typography>
					<Typography variant="body2" color="textSecondary" component="div" sx={classes.cardInfoLine}>
						<p style={{margin: 'unset', color: '#3E3E3E'}}><b>Date de début:</b> {moment(event.start_date).format('DD/MM/YYYY')} - {moment(event.start_date).format('h:mma')}</p>
						<p style={{margin: 'unset', color: '#3E3E3E'}}><b>Date de fin:</b> {moment(event.end_date).format('DD/MM/YYYY')} - {moment(event.end_date).format('h:mma')}</p>
						<p style={{margin: 'unset', color: '#3E3E3E'}}><b>Lieu:</b> {getLabel(event?.fields?.[903858])}</p>
					</Typography>
				</CardContent>
			</Typography>
		</Card>
	)
}

// const categoryColor = (categoryID) => {
// 	const colors = [{id: 16, color: '#f2a928'}, {id: 17, color: '#AE6143'}, {id: 18, color: '#727f21'}, {id: 19, color: '#D7D4C2'}, {id: 20, color: '#d65d0b'}, {id: 21, color: '#146f84'}, {id: 38, color: '#b41440'}]
// 	const categoryInfo =  colors.filter(function(info) {
// 		if(info.id === categoryID){
// 			return info.color
// 		}
// 	})
// 	if(categoryInfo.length > 0){
// 		return categoryInfo[0].color
// 	}

// 	return '#2F875F'
// }

export default EventCard;